var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0945 18.2355L15.2846 14.9826C15.0089 14.4874 14.3544 14.3393 13.8301 14.6535L12.227 15.6139C10.2523 14.2553 8.2362 10.6329 8.0901 8.1791L9.69312 7.21865C10.2177 6.90448 10.4217 6.24273 10.1458 5.74704L8.33593 2.49415C8.06007 1.99846 7.40574 1.85086 6.88141 2.16527L5.20607 3.16886C2.44026 4.82573 5.12028 11.806 6.41764 14.1376C7.71524 16.4696 12.2008 22.3675 14.9664 20.7107L16.6418 19.7071C17.1663 19.3927 17.3701 18.7307 17.0945 18.2355H17.0945Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.6b7e03f6e3cc7b071e3734990bb1a302.svg";
export { ForwardRef as ReactComponent };